import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import * as icons from '@gn-audio/icons';
import { Button, JabraIcon } from '@gn-audio/jss-components';

import {
  FirstButtonSettings,
  SecondButtonSettings,
  SingleButtonProps,
} from 'common/types/buttonTemplateTypes';

type DualButtonBlockProps = FirstButtonSettings &
  SecondButtonSettings & {
    className?: string;
    firstCtaButtonTrackingName?: Field<string>;
    secondCtaButtonTrackingName?: Field<string>;
  };

type ButtonWithIconProps = SingleButtonProps & {
  trackingName?: Field<string>;
  btnAriaLabel?: Field<string>;
};

const ButtonWithIcon = ({
  btnText,
  btnLink,
  btnIcon,
  btnVariant,
  btnSize,
  btnAriaLabel,
  trackingName,
}: ButtonWithIconProps) => {
  if (!btnLink?.value?.href || !btnText?.value) return null;

  return (
    <Button
      asLink
      href={btnLink.value.href}
      size={btnSize?.value || 'm'}
      variant={btnVariant?.value || 'primary'}
      {...(btnIcon?.value && {
        icon: <JabraIcon Icon={icons?.[btnIcon.value]} />,
        iconPlacement: 'right',
      })}
      {...(btnAriaLabel?.value && {
        'aria-label': btnAriaLabel.value,
      })}
      {...(btnLink.value?.target && {
        target: btnLink.value.target,
        rel: 'noopener noreferrer',
      })}
      {...(trackingName?.value && {
        'data-wt-name': trackingName.value,
      })}
    >
      {btnText.value}
    </Button>
  );
};

export const DualButtonBlock = ({
  firstBtnText,
  firstBtnLink,
  firstBtnIcon,
  firstBtnVariant,
  firstBtnSize,
  firstBtnAriaLabel,
  firstCtaButtonTrackingName,
  secondBtnText,
  secondBtnLink,
  secondBtnIcon,
  secondBtnVariant,
  secondBtnSize,
  secondBtnAriaLabel,
  secondCtaButtonTrackingName,
  className = '',
}: DualButtonBlockProps) => {
  const isAnyButtonPresent =
    (!!firstBtnLink?.value?.href && !!firstBtnText?.value) ||
    (!!secondBtnLink?.value?.href && !!secondBtnText?.value);

  if (!isAnyButtonPresent) return null;

  return (
    <section className={`flex flex-row flex-wrap gap-2 ${className}`}>
      <ButtonWithIcon
        btnText={firstBtnText}
        btnLink={firstBtnLink}
        btnIcon={firstBtnIcon}
        btnVariant={firstBtnVariant}
        btnSize={firstBtnSize}
        trackingName={firstCtaButtonTrackingName}
        btnAriaLabel={firstBtnAriaLabel}
      />
      <ButtonWithIcon
        btnText={secondBtnText}
        btnLink={secondBtnLink}
        btnIcon={secondBtnIcon}
        btnVariant={secondBtnVariant}
        btnSize={secondBtnSize}
        trackingName={secondCtaButtonTrackingName}
        btnAriaLabel={secondBtnAriaLabel}
      />
    </section>
  );
};
